import styled from "styled-components";

export const SidebarCountLabel = styled.div`
  margin: 1.6rem 0 0.25rem;
  text-transform: uppercase;
  font-weight: 700;
  line-height: 2;
  letter-spacing: 0.05rem;
  font-size: 1.2rem;
  color: ${(props) => props.theme.textLightColor};
`;

export const SidebarCountValue = styled.div`
  display: inline-block;
  font-size: 2.4rem;
  font-weight: 700;
  line-height: 1;
`;

export const SidebarCountWrapper = styled.div`
  margin-top: 2rem;
  border-top: 1px solid ${(props) => props.theme.borderLightColor};
`;
